import { Crosshair, Flag, Info, Swords, Target, TreePine, Trophy, Users } from "lucide-react";
import { useLang } from "./LangContext";
import { ChapterHead, FadeUp, Soon } from "./Reveal";

const ICONS = {
  crosshair: Crosshair,
  swords: Swords,
  target: Target,
  trophy: Trophy,
  flag: Flag,
  tree: TreePine,
  users: Users,
};

export default function Games() {
  const { t } = useLang();
  const g = t.games;

  return (
    <section id="oyunlar" className="section" data-testid="games-section">
      <div className="wrap">
        <ChapterHead num={g.num} label={g.label} title={g.title} lead={g.lead} />
        <div className="games-grid">
          {g.categories.map((cat, i) => {
            const Icon = ICONS[cat.icon];
            return (
              <FadeUp key={cat.name} delay={(i % 4) * 0.07}>
                <div className="game-card" data-testid={`game-category-${i}`}>
                  <div className="icon-chip" aria-hidden="true">
                    <Icon size={20} strokeWidth={2} />
                  </div>
                  <h3>{cat.name}</h3>
                  <p>{cat.text}</p>
                  <Soon text={g.soonLabel} testid={`game-soon-${i}`} />
                </div>
              </FadeUp>
            );
          })}
        </div>
        <FadeUp delay={0.15}>
          <p className="games-note" data-testid="games-note">
            <Info size={15} aria-hidden="true" />
            {g.note}
          </p>
        </FadeUp>
      </div>
    </section>
  );
}
